import { Injectable } from '@angular/core'

import { SidebarComponent } from './sidebar.component'
import { BehaviorSubject, Observable } from 'rxjs'
import { Navigation } from '@shared/models/navigation.model'

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private sidebar: SidebarComponent
  private navbarItems: BehaviorSubject<Navigation[]> = new BehaviorSubject<Navigation[]>(null)
  navbarItems$: Observable<Navigation[]> = this.navbarItems.asObservable()

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  register(sidebar: SidebarComponent): void {
    this.sidebar = sidebar
  }

  unregister(): void {
    delete this.sidebar
  }

  getSidebar(): SidebarComponent {
    return this.sidebar
  }

  setNavbarItems(items: Navigation[]): void {
    items.sort((a, b) => (a.externalLink === b.externalLink ? 0 : a.externalLink ? 1 : -1))
    this.navbarItems.next(items)
  }

  getNavbarItems(): Navigation[] {
    return this.navbarItems.getValue()
  }
}
